import { Field } from "formik";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";

export default function Details(props) {
	return 	<React.Fragment>
				<Form.Group as={Row} className="mb-3">
					<Form.Label column sm={4}>First Name</Form.Label>
					<Col sm={8}>
						<Field as={Form.Control} name="FirstName" className={`mb-3 ${props.disabled ? "bg-light" : ""}`} readOnly={props.disabled} disabled={props.disabled}></Field>
					</Col>
				</Form.Group>
				<Form.Group as={Row} className="mb-3">
					<Form.Label column sm={4}>Surname</Form.Label>
					<Col sm={8}>
						<Field as={Form.Control} name="Surname" className={`mb-3 ${props.disabled ? "bg-light" : ""}`} readOnly={props.disabled} disabled={props.disabled}></Field>
					</Col>
				</Form.Group>
			</React.Fragment>
}